"use server"

import { sdk } from "@lib/config"

export type ContactMessage = {
  name: string
  email: string
  order_number?: string
  message: string
}

// Forwards a contact-form submission to the backend, which emails the shop
// owner. Boolean result only — the form shows a friendly retry message on
// failure, never raw errors.
export const submitContactMessage = async (
  payload: ContactMessage
): Promise<boolean> => {
  if (!payload.email || !payload.message) {
    return false
  }

  return sdk.client
    .fetch<{ ok: boolean }>(`/store/contact`, {
      method: "POST",
      body: payload,
      cache: "no-store",
    })
    .then(({ ok }) => Boolean(ok))
    .catch(() => false)
}
